<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto space-y-8">
      
      <!-- HEADER -->
      <div class="sci-page-header pb-4">
        <h1 class="sci-page-title-only">Abastecimento</h1>
        <p class="text-sm text-slate-500 font-medium mt-1">Gestão de abastecimentos em nível administrativo</p>
      </div>

      <!-- ÁREA DE PESQUISA -->
      <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm mb-8">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
              <v-icon color="orange" small>mdi-magnify</v-icon>
              <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
                  FILTROS DE PESQUISA
              </h2>
          </div>
          <div class="p-8">
              <v-row>
                  <v-col cols="12" sm="12" md="3">
                    <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Data Inicial</label>
                    <Date @dateValue="[(filter.startDate = $event)]" label="Data Inicial" />
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Data Final</label>
                    <Date @dateValue="[(filter.endDate = $event)]" label="Data Final" />
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                     <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Município</label>
                     <v-autocomplete
                       :items="prefectures"
                       placeholder="SELECIONE..."
                       v-model="filter.prefecture_id"
                       item-value="prefecture_id"
                       item-text="prefecture_social_name"
                       clearable
                       solo flat dense hide-details
                       class="custom-select"
                       height="44"
                       @change="getProviders(filter.prefecture_id)"
                       :disabled="$store.getters.getUserData.table_key == 'prefectures' ? true : false"
                     />
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                     <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Fornecedor</label>
                     <v-autocomplete
                       :items="providers"
                       placeholder="SELECIONE..."
                       v-model="filter.provider_id"
                       item-value="provider_id"
                       item-text="provider_name"
                       clearable
                       solo flat dense hide-details
                       class="custom-select"
                       height="44"
                     />
                  </v-col>
              </v-row>
              <div class="flex justify-end mt-8">
                  <button @click="sendSearch" class="bg-[#333333] hover:bg-slate-900 text-white rounded-lg shadow-md flex items-center justify-center gap-2 w-fit whitespace-nowrap px-10 h-10 transition-all transform hover:-translate-y-0.5 font-bold text-[11px] uppercase tracking-widest">
                      <v-icon color="orange" small class="mr-1" style="font-size: 14px;">mdi-filter-outline</v-icon>
                      FILTRAR RESULTADOS
                  </button>
              </div>
          </div>
      </section>

      <!-- ÁREA DE RESULTADOS -->
      <section class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm">
        <!-- Header Escuro com Ações -->
        <div class="px-6 py-4 flex items-center justify-between" style="background-color: #333333;">
            <div class="flex items-center gap-3">
                <v-icon color="orange" small>mdi-table-list</v-icon>
                <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
                    REGISTROS ENCONTRADOS
                </h2>
            </div>
            
            <div class="flex items-center gap-4 flex-1 justify-end">
                <button 
                  @click="$router.push('/supplies-manager/master/create')"
                  class="bg-orange-500 hover:bg-orange-600 text-white shadow-lg flex items-center justify-center gap-2 rounded-lg px-4 py-2 transition-all w-fit whitespace-nowrap"
                  style="width: auto !important; flex: none !important;"
                >
                  <v-icon color="white" x-small>mdi-plus</v-icon>
                  <span class="font-black text-[10px] uppercase tracking-wider">ADICIONAR</span>
                </button>

                <div class="relative w-80">
                  <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <v-icon color="white" small class="opacity-50">mdi-magnify</v-icon>
                  </div>
                  <input 
                    v-model="search"
                    placeholder="PESQUISAR NOS RESULTADOS..."
                    class="bg-white/10 border border-white/20 rounded-lg py-1.5 pl-10 pr-4 text-[10px] text-white placeholder:text-white/40 focus:outline-none focus:bg-white/20 transition-all w-full uppercase tracking-widest font-bold"
                  >
                </div>

                <v-btn icon dark small @click="sendSearch" class="bg-white/10 hover:bg-white/20 transition-colors">
                  <v-icon small>mdi-refresh</v-icon>
                </v-btn>
            </div>
        </div>

        <div class="p-0">

            <!-- Tabela de Dados -->
            <v-data-table
              :headers="headers"
              :items="data"
              :search="search"
              :items-per-page="8"
              :loading="loader"
              loading-text="CARREGANDO..."
              class="custom-table"
              hide-default-footer
            >
              <template v-slot:item.supply_code="{ item }">
                <span class="font-bold text-slate-700">{{
                  item.supply_code ? item.supply_code : item.vehicle_password
                }}</span>
              </template>
              <template v-slot:item.datehour="{ item }">
                <span class="text-xs text-slate-600 font-semibold">{{ convertDateTime(item.datehour) }}</span>
              </template>
              <template v-slot:item.supply_bidding_price="{ item }">
                <span class="font-medium text-slate-700">{{
                  item.supply_bidding_price
                    ? realMaskII(Number(item.supply_bidding_price).toFixed(3))
                    : 0
                }}</span>
              </template>
              <template v-slot:item.total_billing_price="{ item }">
                <span class="font-black text-slate-800 bg-slate-50 px-2 py-1 rounded">R$ {{
                  item.supply_bidding_price && item.supply_liters_stocked
                    ? realMask(
                        Number(
                          item.supply_bidding_price * item.supply_liters_stocked
                        ).toFixed(2)
                      )
                    : 0
                }}</span>
              </template>
              <template v-slot:item.supply_adjusted="{ item }">
                <span :class="item.supply_adjusted ? 'text-blue-600 bg-blue-50 border border-blue-100 font-black' : 'text-slate-400 font-medium'" class="px-2 py-0.5 rounded-full text-[9px] uppercase tracking-tighter">{{ item.supply_adjusted ? "SIM" : "NÃO" }}</span>
              </template>
              <template v-slot:item.supply_confered="{ item }">
                <span :class="item.supply_confered ? 'text-emerald-600 bg-emerald-50 border border-emerald-100 font-black' : 'text-slate-400 font-medium'" class="px-2 py-0.5 rounded-full text-[9px] uppercase tracking-tighter">{{ item.supply_confered ? "SIM" : "NÃO" }}</span>
              </template>
              <template v-slot:item.supply_billed="{ item }">
                <span :class="item.supply_billed ? 'text-indigo-600 bg-indigo-50 border border-indigo-100 font-black' : 'text-slate-400 font-medium'" class="px-2 py-0.5 rounded-full text-[9px] uppercase tracking-tighter">{{ item.supply_billed ? "SIM" : "NÃO" }}</span>
              </template>
              <template v-slot:item.supply_liters_stocked="{ item }">
                <span class="font-black text-slate-700">{{
                  item.supply_liters_stocked
                    ? realMaskII(Number(item.supply_liters_stocked).toFixed(3))
                    : 0
                }}</span>
              </template>
              <template v-slot:item.item_billing_price="{ item }">
                <span class="font-medium text-slate-700">{{
                  item.item_billing_price
                    ? realMaskII(Number(item.item_billing_price).toFixed(3))
                    : 0
                }}</span>
              </template>
              <template v-slot:item.action="{ item }">
                <div class="flex gap-2 justify-end">
                  <v-tooltip bottom color="slate-800">
                    <template v-slot:activator="{ on, attrs }">
                      <button
                        v-bind="attrs"
                        v-on="on"
                        @click="[(showPassword = true), (password = item.supply_code)]"
                        class="h-8 w-8 rounded-lg bg-slate-50 border border-slate-200 text-slate-400 hover:text-slate-600 hover:bg-white hover:border-slate-300 transition-all flex items-center justify-center"
                      >
                        <v-icon small color="inherit">mdi-eye</v-icon>
                      </button>
                    </template>
                    <span class="font-bold text-[10px] tracking-wider uppercase">Ver Senha</span>
                  </v-tooltip>
                  
                  <v-tooltip bottom color="blue" v-if="item.supply_status != 'CONCLUIDO'">
                    <template v-slot:activator="{ on, attrs }">
                      <button
                        v-bind="attrs"
                        v-on="on"
                        @click="$router.push(`/supplies-manager/master/edit/${item.supply_id}`)"
                        class="h-8 w-8 rounded-lg bg-blue-50 border border-blue-200 text-blue-500 hover:bg-blue-500 hover:text-white transition-all flex items-center justify-center"
                      >
                        <v-icon small color="inherit">mdi-pencil</v-icon>
                      </button>
                    </template>
                    <span class="font-bold text-[10px] tracking-wider uppercase">Editar</span>
                  </v-tooltip>
                  
                  <v-tooltip bottom color="emerald">
                    <template v-slot:activator="{ on, attrs }">
                      <button
                        v-bind="attrs"
                        v-on="on"
                        @click="openModal(item.supply_id)"
                        class="h-8 w-8 rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-500 hover:bg-emerald-500 hover:text-white transition-all flex items-center justify-center"
                      >
                        <v-icon small color="inherit">mdi-square-edit-outline</v-icon>
                      </button>
                    </template>
                    <span class="font-bold text-[10px] tracking-wider uppercase">Corrigir</span>
                  </v-tooltip>
                  
                  <v-tooltip bottom color="rose">
                    <template v-slot:activator="{ on, attrs }">
                      <button
                        v-bind="attrs"
                        v-on="on"
                        @click="deleteItem(item.supply_id)"
                        class="h-8 w-8 rounded-lg bg-rose-50 border border-rose-200 text-rose-500 hover:bg-rose-500 hover:text-white transition-all flex items-center justify-center"
                      >
                        <v-icon small color="inherit">mdi-delete-outline</v-icon>
                      </button>
                    </template>
                    <span class="font-bold text-[10px] tracking-wider uppercase">Excluir</span>
                  </v-tooltip>
                </div>
              </template>
            </v-data-table>

            <!-- Totais Section -->
            <div class="mt-8 border-t border-slate-200 pt-6 flex justify-end items-center text-sm">
                <div class="flex items-center gap-3">
                    <span class="font-bold text-[11px] text-slate-400 uppercase tracking-widest">TOTAL LICITADO</span>
                    <span class="text-sm font-black text-emerald-700 bg-emerald-50 border border-emerald-200 rounded px-3 py-1">
                      R$ {{ totals.bidding_total ? realMask(totals.bidding_total.toFixed(2)) : '0,00' }}
                    </span>
                </div>
            </div>

        </div>
      </section>
    </div>
    <v-dialog v-model="dialog" max-width="600" persistent scrollable>
      <div class="bg-white rounded-xl overflow-hidden shadow-2xl font-sans flex flex-col max-h-[90vh]">
        <!-- Header Escuro -->
        <div class="px-6 py-4 flex justify-between items-center shrink-0" style="background-color: #333333;">
          <div class="flex items-center gap-3">
            <v-icon color="orange" small>mdi-pencil-outline</v-icon>
            <h3 class="text-white font-bold uppercase tracking-widest text-xs">Alterar Abastecimento</h3>
          </div>
          <v-btn icon dark small @click="dialog = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>

        <!-- Body com Scroll -->
        <div class="p-8 overflow-y-auto space-y-6 bg-white">
          <v-form ref="form" v-model="valid">
            <div class="space-y-6">
              <!-- Data e Hora -->
              <div class="bg-slate-50 p-4 rounded-xl border border-slate-200">
                <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Data e Hora</label>
                <v-text-field
                  v-mask="'##/##/#### ##:##'"
                  v-model="dataAdjust.datehour"
                  outlined dense hide-details
                  class="bg-white rounded-lg shadow-sm"
                  prepend-inner-icon="mdi-calendar-clock"
                />
              </div>

              <!-- Veículo -->
              <div class="bg-slate-50 p-4 rounded-xl border border-slate-200">
                <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Veículo</label>
                <v-autocomplete
                  :items="vehicles"
                  item-value="vehicle_id"
                  item-text="vehicle_board"
                  v-model="dataAdjust.vehicle_id"
                  outlined dense hide-details
                  class="bg-white rounded-lg shadow-sm"
                >
                  <template slot="selection" slot-scope="{ item }">
                    <span class="text-xs font-bold" v-if="item">{{ item.vehicle_board }}</span>
                  </template>
                  <template slot="item" slot-scope="{ item }">
                    <div class="flex flex-col py-1" v-if="item">
                      <span class="text-xs font-bold">{{ item.vehicle_board }}</span>
                      <span class="text-[9px] uppercase text-slate-500">{{ item.brand_desc }} - {{ item.model_desc }}</span>
                    </div>
                  </template>
                </v-autocomplete>
              </div>

              <!-- Item -->
              <div class="bg-slate-50 p-4 rounded-xl border border-slate-200">
                <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Item Corrigido</label>
                <v-autocomplete
                  :items="items"
                  item-value="item_id"
                  item-text="item_description_desc"
                  v-model="dataAdjust.item_id"
                  outlined dense hide-details
                  class="bg-white rounded-lg shadow-sm"
                >
                  <template slot="selection" slot-scope="{ item }">
                    <span class="text-xs font-medium" v-if="item">{{ item.item_description_desc }} <span class="text-emerald-600 ml-2">R$ {{ item.item_price ? realMaskII(item.item_price.toFixed(3)) : '0,000' }}</span></span>
                  </template>
                  <template slot="item" slot-scope="{ item }">
                    <span class="text-sm" v-if="item">{{ item.item_description_desc }} <span class="text-emerald-600 ml-2 font-bold">R$ {{ item.item_price ? realMaskII(item.item_price.toFixed(3)) : '0,000' }}</span></span>
                  </template>
                </v-autocomplete>
              </div>

              <!-- Valores Principais -->
                <div class="bg-slate-50 p-4 rounded-xl border border-slate-200">
                  <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Litros Abastecidos</label>
                  <v-text-field
                    v-model="dataAdjust.supply_liters_stocked"
                    v-mask-decimal.br="3"
                    outlined dense hide-details
                    class="bg-white rounded-lg shadow-sm font-bold text-center"
                  />
                </div>

              <!-- Detalhes Extras -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="bg-slate-50 p-4 rounded-xl border border-slate-200">
                  <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Preço Licitado</label>
                  <v-text-field
                    v-model="dataAdjust.supply_bidding_price"
                    v-mask-decimal.br="3"
                    outlined dense hide-details
                    class="bg-white rounded-lg shadow-sm text-center"
                  />
                </div>
                <div class="bg-slate-50 p-4 rounded-xl border border-slate-200">
                  <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Km Informado</label>
                  <v-text-field 
                    v-model="dataAdjust.supply_km" 
                    outlined dense hide-details
                    class="bg-white rounded-lg shadow-sm text-center font-mono"
                    :readonly="!dataAdjust.vehicle_hodometro && !dataAdjust.vehicle_horimetro"
                  />
                </div>
              </div>

              <!-- Cupom e Extra -->
              <div class="space-y-4">
                <div class="bg-slate-50 p-4 rounded-xl border border-slate-200">
                  <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Nº da NF-e</label>
                  <v-text-field
                    v-model="dataAdjust.supply_coupon"
                    outlined dense hide-details
                    class="bg-white rounded-lg shadow-sm"
                  />
                </div>

                <div v-if="dataAdjust.supply_extra" class="bg-amber-50 p-4 rounded-xl border border-amber-100">
                  <label class="block text-[10px] font-black text-amber-500 uppercase tracking-widest mb-2">Justificativa Extra</label>
                  <v-textarea
                    v-model="dataAdjust.justificativa"
                    rows="3"
                    auto-grow outlined dense hide-details
                    class="bg-white rounded-lg shadow-sm"
                  />
                </div>
              </div>
            </div>
          </v-form>
        </div>

        <!-- Footer -->
        <div class="bg-slate-50 px-8 py-6 flex justify-end gap-3 border-t border-slate-200 shrink-0">
          <v-btn
            depressed
            large
            color="secondary"
            @click="dialog = false"
            class="rounded-xl font-bold px-8"
            text
          >
            Cancelar
          </v-btn>
          <v-btn
            depressed
            large
            color="orange"
            :loading="loader"
            @click="ajust"
            class="rounded-xl font-black px-12 shadow-lg white--text"
          >
            Confirmar Correção
          </v-btn>
        </div>
      </div>
    </v-dialog>
    <v-dialog v-model="showPassword" width="300">
      <v-card>
        <v-card-title class="headline primary lighten-2 text-center"
          >COPIE SUA SENHA</v-card-title
        >
        <v-card-text class="mt-6 text-center">
          <v-row>
            <v-col cols="12" sm="12">
              <v-label>
                <input
                  readonly
                  class="text-h4 text-center"
                  style="width: 100%; border: 0; outline: none"
                  ref="copiar"
                  :value="password"
                />
              </v-label>
            </v-col>
            <v-col cols="12" sm="12">
              <v-btn
                :color="copiado ? 'green' : 'primary'"
                depressed
                :dark="copiado"
                block
                @click="copy"
                :outlined="!copiado"
              >
                <v-icon v-if="copiado">mdi-check</v-icon>
                {{ copiado ? "COPIADO" : "COPIAR" }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar
      multi-line
      :color="snack.color"
      v-model="snack.show"
      transition="fade-transition"
    >
      {{ snack.message }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snack.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
import Date from "@/components/InputDate.vue";
export default {
  mixins: [Helpers],
  components: { Date },
  data() {
    return {
      search: "",
      valid: false,
      loader: true,
      dialog: false,
      copiado: false,
      password: "",
      showPassword: false,
      data: [],
      providers: [],
      prefectures: [],
      items: [],
      vehicles: [],
      fieldRules: [(v) => !!v || "Este campo é requerido"],
      prefecture_id: null,
      totals: {
        bidding_total: 0,
        day_value: 0,
      },
      filter: {
        endDate: "",
        startDate: "",
        prefecture_id: null,
        provider_id: null,
      },
      snack: {
        show: false,
        message: "",
        color: "",
      },
      dataAdjust: {
        supply_id: null,
        vehicle_id: null,
        provider_id: null,
        item_id: null,
        supply_liters_stocked: 0,
        supply_price_day: 0,
        supply_coupon: null,
        supply_bidding_price: null,
        supply_bidding_km: null,
        supply_extra: false,
        justificativa: null,
      },
      headers: [
        {
          text: "Data/Hora",
          align: "start",
          value: "datehour",
        },
        { text: "Tipo", value: "item_description_desc" },
        { text: "Qtd", value: "supply_liters_stocked" },
        { text: "Preço Licitado", value: "supply_bidding_price" },
        { text: "T. Licitado", value: "total_billing_price" },
        { text: "Corrigido", value: "supply_adjusted" },
        { text: "Conferido", value: "supply_confered" },
        { text: "Faturado", value: "supply_billed" },
        { text: "NF-e", value: "supply_coupon" },
        { text: "Ações", align: "right", value: "action" },
      ],
    };
  },
  created() {
     if(this.$store.getters.getUserData.table_key == 'prefectures') {
      this.filter.prefecture_id = this.$store.getters.getUserData.table_id
      this.getProviders(this.filter.prefecture_id);
    }
    this.Helpers;
    this.$http.get("/prefectures").then((r) => (this.prefectures = r.data));
    this.loader = false;
  },
  watch: {
    'dataAdjust.vehicle_id': {
      handler(newVal) {
        if (!newVal || !this.vehicles.length) return;
        const vehicle = this.vehicles.find(v => v.vehicle_id === newVal);
        if (vehicle) {
          this.dataAdjust.vehicle_hodometro = !!vehicle.vehicle_hodometro;
          this.dataAdjust.vehicle_horimetro = !!vehicle.vehicle_horimetro;
          if (!this.dataAdjust.vehicle_hodometro && !this.dataAdjust.vehicle_horimetro) {
            this.dataAdjust.supply_km = 0;
          }
        }
      }
    }
  },
  methods: {
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      this.$http
        .get(`/supplies/${this.prefecture_id}`)
        .then((r) => {
          this.data = r.data;
          this.loader = false;
          this.snack.color = "success";
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    sendSearch() {
      this.totals.day_value = 0;
      this.totals.bidding_total = 0;
      this.loader = true;
      this.$http
        .post("/supplies/conferences", this.filter)
        .then((r) => {
          const searchData = r.data;
          let liters = 0;
          let bidding_price = 0;
          let supply_price_day = 0;
          searchData.map((supply) => {
            liters = supply.supply_liters_stocked;
            bidding_price = supply.supply_bidding_price;
            supply_price_day = supply.supply_price_day;
            this.totals.day_value +=
              parseFloat(supply_price_day) * parseFloat(liters);
            this.totals.bidding_total +=
              parseFloat(bidding_price) * parseFloat(liters);
          });
          this.data = searchData;
          this.loader = false;
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.color = "error";
          this.snack.message = e.message;
          this.loader = false;
        });
    },
    copy() {
      var copyTextarea = this.$refs.copiar;
      copyTextarea.select();
      try {
        var successful = document.execCommand("copy");
        if (successful) {
          this.copiado = true;
          setTimeout(() => {
            this.showPassword = false;
            this.copiado = false;
          }, 1000);
        } else {
          alert("não copiado!");
        }
      } catch (err) {
        alert(
          "Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C."
        );
      }
    },
    ajust() {
      delete this.dataAdjust.supply_authorized_liters;
      delete this.dataAdjust.supply_authorized_value;
      this.dataAdjust.supply_status = "CONCLUIDO";
      this.dataAdjust.supply_adjusted = true;
      if (!this.dataAdjust.vehicle_id) {
        this.dataAdjust.vehicle_id = null;
        this.dataAdjust.supply_extra = true;
      }else{
          this.dataAdjust.supply_extra = false;
      }
      this.$http
        .put(`/supplies/single/${this.dataAdjust.supply_id}`, this.dataAdjust)
        .then((r) => {
          this.snack.show = true;
          this.snack.message = r.data.result;
          this.loader = true;
          setTimeout(() => {
            this.dialog = false;
            this.sendSearch();
          }, 1500);
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        });
    },
    openModal(id) {
      this.$http.get(`/supplies/single/${id}`).then((r) => {
        const supplyData = r.data[0];
        
        // Carrega veículos usando a prefeitura da própria supply (não do filtro de busca)
        this.$http
          .get(`/vehicles/supplies/${supplyData.prefecture_id}`)
          .then((v) => {
            if (supplyData.supply_extra) {
              this.vehicles = v.data.filter(i => i.abastecimento_extra)
            } else {
              this.vehicles = v.data;
            }

            // Carrega itens usando o fornecedor da própria supply
            this.$http
              .get(
                `/biddings/items/${supplyData.prefecture_id}/${supplyData.provider_id}`
              )
              .then((i) => {
                this.items = i.data;
                
                // Popula dataAdjust APÓS as listas estarem prontas
                this.dataAdjust = Object.assign({}, supplyData);
                this.dataAdjust.supply_liters_stocked = supplyData.supply_liters_stocked.toFixed(3);
                this.dataAdjust.supply_price_day = supplyData.supply_price_day.toFixed(3);
                this.dataAdjust.supply_bidding_price = supplyData.supply_bidding_price.toFixed(3);
                this.dataAdjust.datehour = this.convertDateTime(supplyData.datehour);
                
                this.dialog = true;
              });
          });
      });
    },
    getProviders(prefecture_id) {
      this.$http
        .get(`/providers/prefecture/${prefecture_id}`)
        .then((r) => (this.providers = r.data));
    },
    deleteItem(id) {
      let c = confirm("Deseja excluir o registro?");
      if (c) {
        this.$store.dispatch("setLoader", true);
        this.$http
          .delete(`/supplies/single/${id}`)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.sendSearch();
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", false);
          });
      }
    },
  },
};
</script>

<style scoped>
.top-bar {
  padding: 30px 15px;
}
.title {
  text-transform: uppercase;
  font-weight: 400;
}
.maxPage {
  width: 100%;
}
.search-field {
  margin-top: 10px;
}
.space {
  margin: 0 10px;
}
</style>